import { useEffect } from 'react';
import { KeyboardData, MouseData } from '../types/hooks';
import {
  useCursor,
  useEditor,
  useHandle,
  useKeyboard,
  useMouse,
} from './useEditor';
import { useScene } from './useScene';

export const interactionHooks = () => {
  const scene = useScene();
  const [handle, setHandle] = useHandle();
  const [, setCursor] = useCursor();
  const [mouse] = useMouse<MouseData>();
  const [keyboard] = useKeyboard<KeyboardData>();
  const { setUI } = useEditor();

  // Select Elements onMouseDown
  useEffect(() => {
    if (mouse.button !== 0) return;

    if (mouse.isDown) {
      if (mouse.hoveredElementID) {
        if (scene.selectedElementIDs.includes(mouse.hoveredElementID)) return;

        if (keyboard.keysDown?.includes('ShiftLeft')) {
          // Hold shift and click to multiselect
          // scene.setSelectedElementIDs((prev) => [
          //   ...prev,
          //   mouse.hoveredElementID!,
          // ]);
        } else {
          // Just click to select single element
          scene.setSelectedElementIDs([mouse.hoveredElementID]);
        }
      } else {
        if (
          mouse.targetID === 'launcherWindow' ||
          mouse.targetID === 'contentContainer' ||
          mouse.targetID === 'toolbarContentContainer'
        ) {
          scene.setSelectedElementIDs([]);
        }
      }
    }
  }, [mouse.isDown]);

  // Set scene offset by dragging
  useEffect(() => {
    if (mouse.isDown) {
      if (mouse.button === 1) {
        scene.setSelectedElementIDs([]);

        scene.setOffset((prev) => ({
          x: prev.x + mouse.movement.x,
          y: prev.y + mouse.movement.y,
        }));
        setHandle({
          x: handle.x + mouse.movement.x,
          y: handle.y + mouse.movement.y,
        });
        setCursor({
          isVisible: false,
        });
        setUI((UI) => ({
          ...UI,
          sceneIsDragging: true,
        }));
      }
    } else {
      setUI((prev) => ({
        ...prev,
        sceneIsDragging: false,
      }));
    }
  }, [mouse.pos, mouse.isDown]);

  useEffect(() => {
    if (
      keyboard.keysDown?.includes('ControlLeft') ||
      keyboard.keysDown?.includes('Meta')
    ) {
      // Disable handle when ctrl is down
      setHandle({ isDisabled: true });

      if (keyboard.keysDown?.includes('KeyZ')) {
        scene.historyUndo();
      }
      if (keyboard.keysDown?.includes('KeyY')) {
        scene.historyRedo();
      }

      if (keyboard.keysDown?.includes('ShiftLeft')) {
        if (keyboard.keysDown?.includes('KeyD')) {
          scene.duplicateSelectedElement();
        }
      }
    } else {
      setHandle({ isDisabled: false });
    }

    if (keyboard.keysDown?.includes('Delete')) {
      scene.deleteSelectedElements();
    }

    if (keyboard.keysDown?.includes('Escape')) {
      scene.setSelectedElementIDs([]);
    }
  }, [keyboard.keysDown]);
};
